import React from "react";
import './universita_partner.scss';
import TemplateComponent from "../../containers/template_page/template_component/template_component";
import {chunk} from "../../utils/utils";

class UniversitaPartner extends TemplateComponent {

    componentRender(data) {
        let partners = data.partners;

        let array = chunk(partners, 2);

        // Creating 3 arrays
        const firstArray = array[0];
        const secondArray = array[1];
        const thirdArray = array[2];

        return (
            <div id='universita_partner'>
                <div className="universita-partner-title col-12 text-center">{data.title}</div>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-3">
                            <ul className="universita-partner-list text-center">
                                {firstArray ? firstArray.map((partner, index) => (
                                    <div key={index} className="universita-partner-link-container">
                                        <li>
                                            <img className="universita-partner-image" src={partner.logo} alt=" "/>
                                        </li>
                                    </div>
                                )) : null}
                            </ul>
                        </div>
                        <div className="col-md-3">
                            <ul className="universita-partner-list text-center">
                                {secondArray ? secondArray.map((partner, index) => (
                                    <div key={index} className="universita-partner-link-container">
                                        <li>
                                            <img className="universita-partner-image" src={partner.logo} alt=" "/>
                                        </li>
                                    </div>
                                )) : null}
                            </ul>
                        </div>
                        <div className="col-md-3">
                            <ul className="universita-partner-list text-center">
                                {thirdArray ? thirdArray.map((partner, index) => (
                                    <div key={index} className="universita-partner-link-container">
                                        <li>
                                            <img className="universita-partner-image" src={partner.logo} alt=" "/>
                                        </li>
                                    </div>
                                )) : null}
                            </ul>
                        </div>
                    </div>
                    <div className="col-12 text-center">

                        <a href={data.btn_link}><button className="universita-partner-button">{data.btn_title}</button></a>
                    </div>
                </div>
            </div>
        )
    }
}

export default UniversitaPartner;
